<script>
    import { createEventDispatcher, onMount } from 'svelte';

    const dispatch = createEventDispatcher();

    onMount(async () => {
        feather.replace();
        dispatch('setActiveTab', {
            tabName: 'Chat'
        });
    })
</script>

Chat here